export default class Room {
  constructor(name, quota) {
    this.name = name;
    this.quota = quota;
  }
}